module.exports = __webpack_public_path__ + "static/img/solutionAdvantageIcon05.afd090b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionAdvantageIcon05.png
// module id = 4SsL
// module chunks = 0